<template>
  <Page
    :title="templateData.title"
    :description="templateData.description"
  >
    <BaseModal default-disabled />
    <component :is="component" />
  </Page>
</template>

<script>
import Page from './Page.vue';
import store from '../store';
import htmlElements from '../utils/HtmlElements';
import TemplateEventHandler from '../utils/TemplateEventHandler';
/* eslint-disable no-undef, vue/one-component-per-file  */
export default {
  name: 'PageTemplateRenderer',

  components: {
    Page,
  },

  mixins: [TemplateEventHandler],

  props: {
    templateData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      component: null,
      hasModal: false,
    };
  },

  computed: {
    pageTemplate() {
      return `<div>${this.buildPageTemplate(this.templateData.elements)}</div>`;
    },
  },

  mounted() {
    const template = Vue.compile(this.pageTemplate);
    this.component = Vue.component('PageTemplate', {
      name: 'PageTemplate',
      store,
      render: template.render,
      staticRenderFns: template.staticRenderFns,
    });
  },

  methods: {
    getComponentName(element) {
      const elementName = element.is || '';

      return elementName[0].toLowerCase() + elementName.slice(1, elementName.length).replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
    },

    getTemplateProps(element) {
      let templateProps = '';

      if (typeof element.props === 'object' && Object.keys(element.props).length > 0) {
        templateProps = `v-bind='${JSON.stringify(element.props)}'`;
      }

      return templateProps.length ? ` ${templateProps.trim()}` : '';
    },

    getElementEvents(element) {
      let elementEvents = '';

      if (typeof element.events === 'object' && Object.keys(element.events).length > 0) {
        this.hasModal = true;

        elementEvents = Object.entries(element.events).map(([event, handler]) => `@${event}='this.GlobalEvents.fire("${handler.name}", ${JSON.stringify(handler.payload)})'`).join(' ');

        Object.values(element.events).forEach(({ name }) => {
          // eslint-disable-next-line no-underscore-dangle
          if (Object.keys(GlobalEvents.vue._events).indexOf(name) === -1) {
            GlobalEvents.listen(name, (payload) => this[name](payload));
          }
        });
      }

      return elementEvents.length ? ` ${elementEvents.trim()}` : '';
    },

    buildPageTemplate(elements) {
      let template = '';

      (Array.isArray(elements) ? elements : [elements] || []).forEach((el) => {
        const element = el;
        const elementTagName = this.getComponentName(element);
        const isHtmlElement = htmlElements.indexOf(elementTagName) !== -1;
        const hasEvents = element.events !== undefined;
        const classString = element.class ? `class="${element.class}"` : '';

        if (typeof element.slots === 'undefined') {
          element.slots = {};
        }

        if (Array.isArray(el.children) && typeof element.slots.default === 'undefined') {
          element.slots.default = el.children;
        }

        template = `${template}<${elementTagName}${this.getTemplateProps(element)}${classString}${hasEvents ? this.getElementEvents(element) : ''}>`;

        if (isHtmlElement && element.text) {
          template = `${template}${element.text}`;
        }

        if (isHtmlElement) {
          Object.values(element.slots || {}).forEach((child) => {
            template = `${template}${this.buildPageTemplate(child)}`;
          });
        } else {
          Object.keys(element.slots || {}).forEach((slotKey) => {
            template = `${template}<template #${slotKey}>${this.buildPageTemplate(element.slots[slotKey])}</template>`;
          });
        }

        template = `${template}</${elementTagName}>`;
      });

      return template;
    },
  },
};
/* eslint-disable no-undef, vue/one-component-per-file  */
</script>
